import { ChangeDetectorRef, Inject, Injectable } from '@angular/core';
import { IRecuperaConfiguracionAplicacionService } from './ports/i-recupera-configuracion-aplicacion-service';
import { AbstractControlOptions, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfiguracionRlt } from '../models/configuracion-rlt';
import { Observable } from 'rxjs';
import { TipoEnvio } from '../../Envios/envios/models/tipo-envio';

@Injectable({
  providedIn: 'root'
})
export class DatosConfiguracionAplicacionService {

  // public configuracionRltForm: FormGroup = new FormGroup({});
  public configuracionRltFormFirmados: FormGroup = new FormGroup({});
  public configuracionRltForm_noFirmados: FormGroup = new FormGroup({});
  configuracionRlt: ConfiguracionRlt;
  nombreDosier: string = '';
  nombreDosier_noFirmados: string = '';
  envio: TipoEnvio = {} as TipoEnvio;
  radioHoraDeshabilitadoFirmados:boolean = false;
  radioHoraDeshabilitado_noFirmados:boolean = false;
  radioDiaMesDeshabilitadoFirmados:boolean = true;
  radioDiaMesDeshabilitado_noFirmados:boolean = true;
  radioTipoDiaDeshabilitadoFirmados:boolean = true;
  radioTipoDiaDeshabilitado_noFirmados:boolean = true;
  rltDesactivadoFirmados:boolean = false;
  rltDesactivado_noFirmados:boolean = false;
  isInit_firmados: boolean = false;
  isInit_noFirmados: boolean = false;

  constructor(@Inject('RecuperaConfiguracionAplicacion') private datosConfiguracionAplicacion: IRecuperaConfiguracionAplicacionService,
              private fb: FormBuilder) {
                this.montarFormularioVacioFirmados();
                this.montarFormularioVacio_noFirmados();

              }

  montarFormularioVacioFirmados(){
    this.configuracionRltFormFirmados = this.fb.group({
      activo:[],
      dosier:[],
      periodicidad:[],
      diaEnvio:[],
      horaEnvio:[],
      cadaDia:[],
      diaMes:[],
      primerUltimoDia:[],
      tipoDia:[],
      frecuenciaMensual:[]
    })
  }

  montarFormularioVacio_noFirmados(){
    this.configuracionRltFormFirmados = this.fb.group({
      activo:[],
      dosier:[],
      periodicidad:[],
      diaEnvio:[],
      horaEnvio:[],
      cadaDia:[],
      diaMes:[],
      primerUltimoDia:[],
      tipoDia:[],
      frecuenciaMensual:[],
      diasRetraso:[]
    })
  }

  iniciaConfiguracionRltForm(){
    this.isInit_firmados = true;
    this.rltDesactivadoFirmados = !this.configuracionRlt.activo;
    this.configuracionRltFormFirmados = this.fb.group({
      activo:[this.configuracionRlt.activo],
      dosier:[this.nombreDosier],
      periodicidad:[this.configuracionRlt.periodicidad, Validators.required],
      diaEnvio:[this.configuracionRlt.diaEnvio, Validators.required],
      horaEnvio:[this.configuracionRlt.hora, Validators.required],
      cadaDia: [this.configuracionRlt.cadaDia, Validators.required],
      diaMes: [this.configuracionRlt.diaMes, Validators.required],
      primerUltimoDia: [this.configuracionRlt.primerUltimoDia, Validators.required],
      tipoDia: [this.configuracionRlt.tipoDia, Validators.required],
      frecuenciaMensual: [this.getFrecuenciaMensualFirmados(), Validators.required]
    })
    this.habilitarRadio(this.getFrecuenciaMensualFirmados(), 'firmados');
    this.setFormEnabled(!this.getRltDesactivado('firmados'), 'firmados');
  }

  iniciaConfiguracionRltForm_noFirmados(){
    this.isInit_noFirmados = true;
    this.rltDesactivado_noFirmados = !this.configuracionRlt.activo_noFirmados;
    this.configuracionRltForm_noFirmados = this.fb.group({
      activo:[this.configuracionRlt.activo_noFirmados],
      dosier:[this.nombreDosier_noFirmados],
      periodicidad:[this.configuracionRlt.periodicidad_noFirmados, Validators.required],
      diaEnvio:[this.configuracionRlt.diaEnvio_noFirmados, Validators.required],
      horaEnvio:[this.configuracionRlt.hora_noFirmados, Validators.required],
      cadaDia: [this.configuracionRlt.cadaDia_noFirmados, Validators.required],
      diaMes: [this.configuracionRlt.diaMes_noFirmados, Validators.required],
      primerUltimoDia: [this.configuracionRlt.primerUltimoDia_noFirmados, Validators.required],
      tipoDia: [this.configuracionRlt.tipoDia_noFirmados, Validators.required],
      frecuenciaMensual: [this.getFrecuenciaMensual_noFirmados(), Validators.required],
      diasRetraso: [this.configuracionRlt.diasRetraso_noFirmados]
      // diasRetraso: [this.configuracionRlt.diasRetraso_noFirmados, Validators.required]
    })
    this.habilitarRadio(this.getFrecuenciaMensual_noFirmados(), 'noFirmados');
    this.setFormEnabled(!this.getRltDesactivado('noFirmados'), 'noFirmados');
  }

  getFormByTipo(tipo: string): FormGroup {
    return tipo === 'firmados'
      ? this.configuracionRltFormFirmados
      : this.configuracionRltForm_noFirmados;
  }

  getRltDesactivado(tipo: string): boolean {
    return tipo === 'firmados' ? this.rltDesactivadoFirmados : this.rltDesactivado_noFirmados;
  }

  getActivo(tipo: string) {
    return this.getFormByTipo(tipo).get('activo');
  }
  getPeriodicidad(tipo: string) {
    return this.getFormByTipo(tipo).get('periodicidad');
  }
  getCadaDia(tipo: string) {
    return this.getFormByTipo(tipo).get('cadaDia');
  }
  getHoraEnvio(tipo: string) {
    return this.getFormByTipo(tipo).get('horaEnvio');
  }
  getDiaEnvio(tipo: string) {
    return this.getFormByTipo(tipo).get('diaEnvio');
  }
  getDiaMes(tipo: string) {
    return this.getFormByTipo(tipo).get('diaMes');
  }
  getPrimerUltimoDia(tipo: string) {
    return this.getFormByTipo(tipo).get('primerUltimoDia');
  }
  getTipoDia(tipo: string) {
    return this.getFormByTipo(tipo).get('tipoDia');
  }
  getFrecuenciaMensual(tipo: string) {
    return this.getFormByTipo(tipo).get('frecuenciaMensual');
  }
  getDiasRetraso(tipo: string) {
    return this.getFormByTipo(tipo).get('diasRetraso');
  }

  toggleActivado(event: any, tipo:string){
    this.getActivo(tipo).setValue(event);
    if(tipo==='firmados') this.rltDesactivadoFirmados = !event;
    if(tipo==='noFirmados') this.rltDesactivado_noFirmados = !event;
    if(!event) this.getDiasRetraso(tipo).setValue(0);
    this.setFormEnabled(event, tipo);
  }

  getFrecuenciaSeleccionada(frecuencia: any, tipo: string) {
    this.getPeriodicidad(tipo).setValue(frecuencia);
    switch (frecuencia) {
      case 'Diaria':
        this.getCadaDia(tipo).enable();
        this.resetSemanal(tipo);
        this.resetMensual(tipo);
        break;
      case 'Semanal':
      case 'Quincenal':
        this.getDiaEnvio(tipo).enable();
        this.resetDiaria(tipo);
        this.resetMensual(tipo);
        this.resetDesdeSemanalQuincenal(tipo);
        break;
      case 'Mensual':
        this.getFrecuenciaMensual(tipo).enable();
        this.getHoraEnvio(tipo).disable();
        this.resetDiaria(tipo);
        this.resetSemanal(tipo);
        break;
    }
    if(this.isInit_firmados && tipo === 'firmados') {
      this.isInit_firmados = false;
      this.getHoraEnvio(tipo).setValue(this.configuracionRlt.hora);
      if(frecuencia === 'Semanal' || frecuencia === 'Quincenal') {
        this.getDiaEnvio(tipo).setValue(this.configuracionRlt.diaEnvio);
      }
    }
    if(this.isInit_noFirmados && tipo === 'noFirmados') {
      this.isInit_noFirmados = false;
      this.getHoraEnvio(tipo).setValue(this.configuracionRlt.hora_noFirmados);
      if(frecuencia === 'Semanal' || frecuencia === 'Quincenal') {
        this.getDiaEnvio(tipo).setValue(this.configuracionRlt.diaEnvio_noFirmados);
      }
    }
  }

  getFrecuenciaMensualFirmados():string{
    if(this.configuracionRlt.diaMes!==0 && this.configuracionRlt.diaMes!==null){
      return 'diaDelMes';
    }else if(this.configuracionRlt.primerUltimoDia!=='' &&
             this.configuracionRlt.primerUltimoDia!==null &&
             this.configuracionRlt.tipoDia!=='' &&
             this.configuracionRlt.tipoDia!==null){
              return 'tipoDeDia';
             }
    return '';
  }

  getFrecuenciaMensual_noFirmados():string{
    if(this.configuracionRlt.diaMes_noFirmados!==0 && this.configuracionRlt.diaMes_noFirmados!==null){
      return 'diaDelMes';
    }else if(this.configuracionRlt.primerUltimoDia_noFirmados!=='' &&
             this.configuracionRlt.primerUltimoDia_noFirmados!==null &&
             this.configuracionRlt.tipoDia_noFirmados!=='' &&
             this.configuracionRlt.tipoDia_noFirmados!==null){
              return 'tipoDeDia';
             }
    return '';
  }

  getRadioDiaMesDeshabilitado(tipo: string): boolean {
  return tipo === 'firmados' ? this.radioDiaMesDeshabilitadoFirmados : this.radioDiaMesDeshabilitado_noFirmados;
  }

  setRadioDiaMesDeshabilitado(tipo: string, value: boolean): void {
    if (tipo === 'firmados') {
      this.radioDiaMesDeshabilitadoFirmados = value;
    } else {
      this.radioDiaMesDeshabilitado_noFirmados = value;
    }
  }

  getRadioTipoDiaDeshabilitado(tipo: string): boolean {
    return tipo === 'firmados' ? this.radioTipoDiaDeshabilitadoFirmados : this.radioTipoDiaDeshabilitado_noFirmados;
  }

  setRadioTipoDiaDeshabilitado(tipo: string, value: boolean): void {
    if (tipo === 'firmados') {
      this.radioTipoDiaDeshabilitadoFirmados = value;
    } else {
      this.radioTipoDiaDeshabilitado_noFirmados = value;
    }
  }

  getRadioHoraDeshabilitado(tipo: string): boolean {
    return tipo === 'firmados' ? this.radioHoraDeshabilitadoFirmados : this.radioHoraDeshabilitado_noFirmados;
  }

  setRadioHoraDeshabilitado(tipo: string, value: boolean): void {
    if (tipo === 'firmados') {
      this.radioHoraDeshabilitadoFirmados = value;
    } else {
      this.radioHoraDeshabilitado_noFirmados = value;
    }
  }

  habilitarRadio(tipoRadio:string, tipo:string){
    switch(tipoRadio){
      case 'diaDelMes':
        this.setRadioDiaMesDeshabilitado(tipo, false);
        this.setRadioTipoDiaDeshabilitado(tipo, true);
        this.getDiaMes(tipo).enable();
        this.getPrimerUltimoDia(tipo).disable();
        this.getTipoDia(tipo).disable();
        this.getFormByTipo(tipo).patchValue({
          primerUltimoDia: null,
          tipoDia: null
        });
        this.getFormByTipo(tipo).updateValueAndValidity();
      break;
      case 'tipoDeDia':
        this.setRadioDiaMesDeshabilitado(tipo, true);
        this.setRadioTipoDiaDeshabilitado(tipo, false);
        this.getDiaMes(tipo).disable();
        this.getPrimerUltimoDia(tipo).enable();
        this.getTipoDia(tipo).enable();
        this.getFormByTipo(tipo).patchValue({
          diaMes: 0
        });
        this.getFormByTipo(tipo).updateValueAndValidity();
      break;
    }
    this.setRadioHoraDeshabilitado(tipo, false);
    this.getHoraEnvio(tipo).enable();
  }

  setFormEnabled(enabled: boolean, tipo:string) {
    Object.keys(this.getFormByTipo(tipo).controls).forEach(key => {
      if (enabled) {
        this.getPeriodicidad(tipo).enable();
        this.getHoraEnvio(tipo).enable();
      } else {
        this.getFormByTipo(tipo).controls[key].disable();
        this.getPeriodicidad(tipo).setValue('');
        this.getHoraEnvio(tipo).setValue('');
        this.resetDiaria(tipo);
        this.resetSemanal(tipo);
        this.resetMensual(tipo);
      }
    });
  }

  resetDiaria(tipo:string){
    this.getCadaDia(tipo).setValue(0);
    this.getCadaDia(tipo).disable();
    this.getHoraEnvio(tipo).setValue('');
  }

  resetSemanal(tipo:string){
    this.getDiaEnvio(tipo).setValue('');
    this.getDiaEnvio(tipo).disable();
    this.getHoraEnvio(tipo).setValue('');
  }

  resetDesdeSemanalQuincenal(tipo:string){
    this.getDiaEnvio(tipo).setValue('');
    this.getHoraEnvio(tipo).setValue('');
  }

  resetMensual(tipo:string){
    this.getDiaMes(tipo).setValue(0);
    this.getDiaMes(tipo).disable();
    this.getPrimerUltimoDia(tipo).setValue('');
    this.getPrimerUltimoDia(tipo).disable();
    this.getTipoDia(tipo).setValue('');
    this.getTipoDia(tipo).disable();
    this.getFrecuenciaMensual(tipo).setValue('');
    this.getFrecuenciaMensual(tipo).disable();
    this.setRadioDiaMesDeshabilitado(tipo, true);
    this.setRadioTipoDiaDeshabilitado(tipo, true);
    this.setRadioHoraDeshabilitado(tipo, true);
    this.getHoraEnvio(tipo).setValue('');
  }

  getSeleccion(seleccion:any, campo:string, tipo:string){
    this.getFormByTipo(tipo).controls[campo].setValue(seleccion);
  }

  guardaConfiguracionRlt(objetoConfiguracionRlt: ConfiguracionRlt): Observable<void>{
    return this.datosConfiguracionAplicacion.guardaConfiguracionRlt(objetoConfiguracionRlt);
  }

  getConfiguracionRlt(){
    return this.datosConfiguracionAplicacion.getConfiguracionRlt();
  }
}
